<template>
<div class="tiger-title"
     :style="{textAlign: position}"
     v-intersect="{class: 'my-animated-comm animate__fadeInUp'}">
  <div class="en-32 en-title">
    <slot name="en"></slot>
  </div>
  <div class="cn-32-semi">
    <slot name="cn"></slot>
  </div>
</div>
</template>

<script>
export default {
  name: "TigerTitle",

  props: {
    position: {
      type: String,
      default: 'left'
    }
  }
}
</script>

<style lang="scss" scoped>
.tiger-title {
  .en-title {
    p {
      color: $col-primary-yellow;
    }
  }

  p {
    line-height: 1.4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TigerTitle/index.vue